import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appAccessibleClick]',
  standalone: true
})
export class AccessibleClickDirective {
  constructor(private el: ElementRef) {
    // Make element focusable if it's not already
    if (!this.el.nativeElement.hasAttribute('tabindex')) {
      this.el.nativeElement.setAttribute('tabindex', '0');
    }
    
    // Add role="button" if it's not a button element
    if (!['BUTTON', 'A'].includes(this.el.nativeElement.tagName)) {
      this.el.nativeElement.setAttribute('role', 'button');
    }
  }

  @HostListener('keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.el.nativeElement.click();
    }
  }

  @HostListener('click', ['$event'])
  handleClick(event: MouseEvent) {
    // Prevent default action for non-button elements
    if (!['BUTTON', 'A'].includes(this.el.nativeElement.tagName)) {
      event.preventDefault();
    }
  }
}
